import { Controller } from "@hotwired/stimulus";

function setColorScheme(value) {
  const domain = window.location.hostname.split(".").slice(-3).join(".");
  if (value) {
    document.cookie = `colorScheme=${value}; path=/; domain=${domain}; max-age=${365 * 24 * 60 * 60}; SameSite=Lax`;
  } else {
    document.cookie = `colorScheme=; path=/; domain=${domain}; max-age=0; SameSite=Lax`;
  }
}

export default class extends Controller {
  static targets = ["system", "light", "dark"];

  connect() {
    this.handleSystem = this.selectSystem.bind(this);
    this.handleLight = this.selectLight.bind(this);
    this.handleDark = this.selectDark.bind(this);

    this.systemTarget.addEventListener("click", this.handleSystem);
    this.lightTarget.addEventListener("click", this.handleLight);
    this.darkTarget.addEventListener("click", this.handleDark);
  }

  disconnect() {
    this.systemTarget.removeEventListener("click", this.handleSystem);
    this.lightTarget.removeEventListener("click", this.handleLight);
    this.darkTarget.removeEventListener("click", this.handleDark);
  }

  selectSystem(e) {
    e.preventDefault();
    setColorScheme(null);
    document.documentElement.setAttribute("data-color-scheme", "system");
    if (
      window.matchMedia &&
      (window.matchMedia("(prefers-color-scheme: dark)").matches ||
        window.matchMedia("(prefers-color-scheme: no-preference)").matches)
    ) {
      document.documentElement.style.colorScheme = "dark";
      document.documentElement.classList.add("dark-mode");
    } else {
      document.documentElement.style.colorScheme = "light";
      document.documentElement.classList.remove("dark-mode");
    }
  }

  selectLight(e) {
    e.preventDefault();
    document.documentElement.classList.remove("dark-mode");
    document.documentElement.setAttribute("data-color-scheme", "light");
    document.documentElement.style.colorScheme = "light";
    setColorScheme("light");
  }

  selectDark(e) {
    e.preventDefault();
    document.documentElement.classList.add("dark-mode");
    document.documentElement.setAttribute("data-color-scheme", "dark");
    document.documentElement.style.colorScheme = "dark";
    setColorScheme("dark");
  }
}
